var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTakeHandDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.317,
    height: 125.988
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Take_Hand_Desktop_svg__a",
    x: 0,
    y: 23.195,
    width: 209.755,
    height: 102.793,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Take_Hand_Desktop_svg__b",
    x: 180.461,
    y: 0,
    width: 59.856,
    height: 59.879,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Take_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002 .001)",
    filter: "url(#Take_Hand_Desktop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3848",
    d: "M141.787 78.6l63.472-31.326L187.344 24.7 129.41 56.309h-.121L59.793 79.821a.739.739 0 01-.567 0 26.994 26.994 0 00-12.591-2.895 1.133 1.133 0 01-.314 0L32.41 71.309a3.917 3.917 0 00-4.747 2.024 4.049 4.049 0 001.316 5.061l9.514 3.381h.081l.142.111a.172.172 0 01.061.061.577.577 0 01.121.182.8.8 0 010 .223 7.024 7.024 0 000 .86 8.36 8.36 0 00.941 3.1c1.012 1.953 3.7 3.239 5.182 3.664a3.38 3.38 0 00.83.152.759.759 0 010 1.518c-1.417 0-5.749-1.619-7.358-4.625A9.707 9.707 0 0137.41 83.5a119.757 119.757 0 01-19.079 6.488 84.109 84.109 0 00-11.943 4.15 2.662 2.662 0 00-1.741 3.421A3.107 3.107 0 008.569 99.5c1.741-.516 17.287-5.061 18.219-5.213a.749.749 0 01.85.5.759.759 0 01-.364.921c-3.381 1.771-9.109 4.656-13.279 6.771l-5.4 2.794c-2.976 1.559-3.31 2.024-2.5 3.623 1.5 2.976 8.219-.192 8.492-.324l13.259-7.085a.759.759 0 011.012.324.749.749 0 01-.314 1.012l-13.234 7.008c-2.419 1.366-4.919 2.925-5.192 4.16a1.285 1.285 0 00.314 1.012c1.791 2.46 5.395.9 8.684-1.012l4.818-2.5h.061l9.646-6.225a.759.759 0 11.83 1.265l-9.605 6.346a.415.415 0 01-.111.121c-2.439 1.64-3.036 3.573-2.308 4.636s3.036 1.377 5.85-.455c3.634-2.348 7.277-5 11.012-7.723a.648.648 0 01.354-.142 68.827 68.827 0 0010.647-2.873c8.573-3.036 12.227-6.164 14.9-9.109a.739.739 0 01.395-.223c17.328-3.947 60.546-14.17 73.532-17.48a13.431 13.431 0 002.652-1.032z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1169",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.931 109.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3849",
    d: "M14.992 109.17h-.061",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002 .001)",
    filter: "url(#Take_Hand_Desktop_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3850",
    d: "M231.255 9.526a21.164 21.164 0 00-29.727-3.451L184.96 19.233l2.773 3.492.486.607.476.607 17.945 22.622.486.607.486.607 3.658 4.605 16.564-13.16a21.184 21.184 0 003.421-29.7z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3851",
    d: "M232.441 8.583a22.662 22.662 0 00-31.853-3.664l-17.206 13.623a.719.719 0 00-.283.506.769.769 0 00.162.557l3.036 3.887-57.692 31.447-69.008 23.34a28.249 28.249 0 00-12.854-2.844l-13.8-5.547a5.425 5.425 0 00-6.68 2.8 5.557 5.557 0 001.925 7.089.809.809 0 00.162.081l7.864 2.794a122.47 122.47 0 01-18.216 6.073 84.452 84.452 0 00-12.216 4.018 4.19 4.19 0 00-2.581 5.283 4.646 4.646 0 005.769 2.925l10.962-3.168-6.579 3.33-5.465 2.773c-2.449 1.275-4.757 2.48-3.158 5.658 1.012 2.024 3.208 2.277 5.354 2.024a4.352 4.352 0 00-1.437 2.166 2.743 2.743 0 00.567 2.277c2.834 3.9 8.31.789 10.628-.516l1.2-.628a3.7 3.7 0 00.162 3.553 3.826 3.826 0 003.312 1.58 8.765 8.765 0 004.605-1.579c3.6-2.338 7.227-4.96 10.921-7.662a71.2 71.2 0 0010.769-2.915c8.725-3.036 12.571-6.316 15.354-9.362 17.49-3.988 60.4-14.17 73.34-17.439a15.524 15.524 0 002.945-1.083l63.765-31.478 4.332 5.455a.759.759 0 00.6.294.789.789 0 00.476-.172l17.205-13.624a22.692 22.692 0 003.613-31.852zM211.267 52.4l-3.654-4.605-.486-.607-.486-.607-17.945-22.613-.476-.607-.486-.607-2.773-3.522L201.53 6.073a21.162 21.162 0 0126.316 33.148zM65.205 97.277c-2.672 2.966-6.326 6.073-14.9 9.109a68.825 68.825 0 01-10.648 2.925.648.648 0 00-.354.142c-3.735 2.723-7.379 5.374-11.012 7.723-2.834 1.832-5.061 1.619-5.85.455s-.132-3.036 2.308-4.636a.415.415 0 00.111-.121l9.605-6.346a.759.759 0 10-.83-1.265l-9.636 6.366h-.061l-4.818 2.5c-3.289 1.862-6.893 3.421-8.684 1.012a1.285 1.285 0 01-.314-1.012c.273-1.235 2.773-2.794 5.192-4.16l13.229-7.014a.749.749 0 00.314-1.012.759.759 0 00-1.012-.324L14.588 108.7c-.273.132-6.994 3.3-8.492.324-.81-1.589-.476-2.024 2.5-3.623l5.445-2.763c4.13-2.287 9.889-5.172 13.239-6.943a.759.759 0 00.364-.921.749.749 0 00-.85-.5c-1.012.182-16.518 4.7-18.219 5.213a3.107 3.107 0 01-3.917-1.937 2.662 2.662 0 011.73-3.421 84.11 84.11 0 0112.075-3.917 119.756 119.756 0 0019.079-6.488 9.706 9.706 0 001.083 3.522c1.609 3.036 5.941 4.625 7.358 4.625a.759.759 0 100-1.518 3.381 3.381 0 01-.83-.152c-1.478-.425-4.14-1.711-5.182-3.664a8.36 8.36 0 01-.941-3.1 7.024 7.024 0 010-.86.8.8 0 000-.223.577.577 0 00-.121-.182.172.172 0 00-.061-.061L38.707 82h-.081l-9.514-3.381a4.049 4.049 0 01-1.316-5.061 3.917 3.917 0 014.747-2.024l13.775 5.389a1.133 1.133 0 00.314 0 26.994 26.994 0 0112.591 2.824.739.739 0 00.567 0l69.498-23.462h.121L187.34 24.7l17.915 22.571-63.467 31.373a13.43 13.43 0 01-2.652 1.012c-12.986 3.209-56.184 13.462-73.532 17.4a.739.739 0 00-.395.223zM14.931 109.2z"
  }))));
}

export default __webpack_public_path__ + "static/media/Take_Hand_Desktop.b0bbf40560278fcc23386eac2b66337f.svg";
export { SvgTakeHandDesktop as ReactComponent };